module.exports = __webpack_public_path__ + "img/notif-diskon-img.7501a2f1.svg";